module.exports = __webpack_public_path__ + "static/img/cover4.2e6e0b94.svg";